// @src/pre-deployment/src/utils/emailTemplates.js v1.0
// - Email template configurations for pre-deployment environment
// - Uses same settings as main app for consistency

export const getEmailActionSettings = (continueUrl) => {
  // Use appropriate domain based on environment
  const baseUrl = window.location.hostname === 'localhost' 
    ? 'http://localhost:3003'  // Pre-deployment local testing (port 3003)
    : 'https://learnwithnoonchi.com';  // Custom domain for pre-production app
  
  const finalUrl = continueUrl.startsWith('http') 
    ? continueUrl 
    : `${baseUrl}${continueUrl.startsWith('/') ? continueUrl : '/' + continueUrl}`;

  console.log('📧 EMAIL TEMPLATES: Action settings configured');
  console.log('Base URL:', baseUrl);
  console.log('Final URL:', finalUrl);
  console.log('⚠️ PRE-DEPLOYMENT: Using port 3003 for local development');
  
  return {
    url: finalUrl,
    handleCodeInApp: true,
    iOS: {
      bundleId: 'com.landingpagedemo.app'
    },
    android: {
      packageName: 'com.landingpagedemo.app',
      installApp: true,
      minimumVersion: '12'
    }
  };
};
